var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.cargos),function(item,index){return _c('bk-cargos',{key:index,attrs:{"id":index,"item":item,"maxDiscount":_vm.maxDiscount},on:{"toSetCargo":_vm.toSetCargo}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }